package org.example.project.dashboard

import org.example.project.manager.NodeScope

import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import kotlinx.browser.window
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Iframe
import org.example.project.enginechat.ChatModuleScreen
import org.example.project.enginechat.MobileChatLayout
import org.example.project.enginemodule.ModulEditor
import org.example.project.enginemodule.ModulShop
import org.example.project.enginemodule.ModulShopViewMode
import org.example.project.enginemodule.ModulShopLayout
import org.example.project.enginepalettenkonto.PalAuskunftScreen
import org.example.project.enginepalettenkonto.PalDashboardScreen
import org.example.project.enginepalettenkonto.CusDispoDashboard
import org.example.project.screens_cus.CusInfrastrukturDashboard
import org.example.project.screens_cus.CusInfrageneratorDashboard
import org.example.project.screens_cus.CusHofDashboard
import org.example.project.screens_cus.CusZeitfensterDashboard
import org.example.project.enginepalettenkonto.PalDifferenzenScreen
import org.example.project.enginepalettenkonto.PalJournalScreen
import org.example.project.enginepalettenkonto.PalVerarbeitungScreen
import org.example.project.enginepersonal.AnwesenheitsverwaltungScreen
import org.example.project.enginepersonal.BuchungsjournalScreen
import org.example.project.enginepersonal.CUSUrlaubsuebersicht
import org.example.project.enginepersonal.CUSZeitverwaltung
import org.example.project.enginepersonal.PersonalverwaltungScreen
import org.example.project.enginepersonal.StempelkarteScreen
import org.example.project.enginepersonal.StempeluhrScreen
import org.example.project.enginepersonal.StempeluhrGeneratorScreen
import org.example.project.enginesmartring.EngineSmartRingScreen
import org.example.project.engineslot.SlotSetup
import org.example.project.engineslot.SlotView
import org.example.project.enginetabular.TabularCreator
import org.example.project.screens_lizenz.LIZMaskenLizenzierung
import org.example.project.engineservice.cr.CUSCRErstellung
import org.example.project.screens_cus.CUSCRAuskunft
import org.example.project.screens_cus.CUSCeoDashboard
import org.example.project.screens_cus.CUSSystemDashboardScreen
import org.example.project.screens_cus.CUSKundenverbrauch
import org.example.project.screens_cus.CUSRechnungsuebersicht
import org.example.project.screens_cus.CUSTerminauskunft
import org.example.project.screens_cus.CUSSupportAuskunft
import org.example.project.screens_cus.CUSInfrastrukturverwaltung
import org.example.project.screens_cus.CUSKontrollverwaltung
import org.example.project.screens_cus.CUSLhmTypverwaltung
import org.example.project.screens_cus.CUSSnapverwaltung
import org.example.project.screens_cus_mobile.wa.CUSMobileWAFlowScreen
import org.example.project.screens_cus_mobile.wa.CUSMobileWAStandortKontrolleScreen
import org.example.project.screens_cus_mobile.wa.CUSMobileWAKontrolleScreen
import org.example.project.screens_cus_mobile.we.CUSMobileWEFlowScreen
import org.example.project.screens_cus_mobile.we.CUSMobileWEWebKontrolleScreen
import org.example.project.screens_cus_mobile.MitarbeiterKalender
import org.example.project.screens_cus_mobile.AufgabenViewerScreen
import org.example.project.screens_cus_mobile.MitarbeiterMeinUrlaub
import org.example.project.screens_cus_mobile.MitarbeiterZeitkonto
import org.example.project.screens_cus_mobile.MobileArbeitszeiterfassung
import org.example.project.screens_cus.CUSPalettenArtenVerwaltung
import org.example.project.screens_cus.CUSPalettenTypverwaltung
import org.example.project.screens_cus.CUSParkplatzAuskunft
import org.example.project.screens_cus.CUSParkplatzTorverwaltung
import org.example.project.screens_cus.CUSPlatzAuskunft
import org.example.project.enginecardview.CUSRegaluebersicht
import org.example.project.screens_cus.CUSStandortverwaltung
import org.example.project.screens_cus.standortverwaltungKarteiPages
import org.example.project.screens_net.NETStandortverwaltung
import org.example.project.screens_net.netstandortverwaltungKarteiPages
import org.example.project.engineservice.support.CUSSupportFlow
import org.example.project.engineservice.schulung.SchulungsFlow
import org.example.project.engineservice.schulung.SchulungsAuskunft
import org.example.project.engineservice.schulung.Schulungsverwaltung
import org.example.project.screens_cus.CUSTorAuskunft
import org.example.project.enginecardview.CUSTorUebersicht
import org.example.project.screens_cus.CUSWAPlatzTorverwaltung
import org.example.project.screens_cus.CUSWAPlatzAuskunft
import org.example.project.enginecardview.CUSWAPlatzUebersicht
import org.example.project.screens_cus.CUSWETorfreigabeScreen
import org.example.project.screens_shared.SHAREDBereichsverwaltung
import org.example.project.screens_shared.SHAREDUserverwaltung
import org.example.project.screens_shared.SHAREDUserverwaltungTabelle
import org.example.project.screens_shared.SHAREDKarteiSettings
import org.example.project.screens_shared.SHAREDYardSettings
import org.example.project.screens_shared.SHAREDLoginauskunft
import org.example.project.screens_shared.SHAREDMeineFahrerAuftraege
import org.example.project.screens_shared.SHAREDMeineSlotAuftraege
import org.example.project.screens_shared.SHAREDSnapAuftraegeDashboard
import org.example.project.screens_shared.SHAREDMeineAuflieger
import org.example.project.screens_shared.SHAREDMeineZugmaschienen
import org.example.project.screens_shared.SHAREDTerminverwaltung
import org.example.project.screens_shared.SHAREDAufgabenverwaltung
import org.example.project.screens_shared.SHAREDNotitzen
import org.example.project.screens_shared.MobileNotepadLayout
import org.example.project.screens_shared.SHAREDRollenverwaltung
import org.example.project.screens_shared.SHAREDEndToEndFlow
import org.example.project.screens_shared.userverwaltungKarteiPages
import org.example.project.screens_sys.SYSCRAuskunft
import org.example.project.screens_sys.Firmenregister
import org.example.project.screens_sys.Kundensetup
import org.example.project.enginevertrieb.Vertriebspool
import org.example.project.enginevertrieb.MeineLeads
import org.example.project.enginevertrieb.LinkedInLeadUebernahme
import org.example.project.enginevertrieb.LinkedInChat
import org.example.project.enginevertrieb.VertriebsDashboard
import org.example.project.enginevertrieb.SysVertriebsDashboard
import org.example.project.enginevertrieb.Vertriebsindex
import org.example.project.enginevertrieb.Konkurrenzindex
import org.example.project.enginevertrieb.Leaduebersicht
import org.example.project.enginevertrieb.AkquiseEinstellungen
import org.example.project.screens_sys.Sys_Kundenabrechnung
import org.example.project.screens_sys.SysKundenDashboard
import org.example.project.enginefinanzen.Sys_Rechnungsuebersicht
import org.example.project.enginefinanzen.SysBetriebsausgabenScreen
import org.example.project.enginefinanzen.SysEingangsrechnungenScreen
import org.example.project.enginefinanzen.SysFinanzDashboardScreen
import org.example.project.enginefinanzen.SysFinanzWrapper
import org.example.project.enginefinanzen.SysFinanzamtQuartaleScreen
import org.example.project.enginefinanzen.SysAbgabeeinstellungenScreen
import org.example.project.screens_sys.ServerUebersicht
import org.example.project.screens_sys.SysFeedControlScreen
import org.example.project.screens_sys.SysModulauskunft
import org.example.project.screens_sys.SysSystemDashboard
import org.example.project.screens_sys.SysSystemBuildScreen
import org.example.project.screens_sys.SysBuildDashboard
import org.example.project.screens_sys.SysBuildUebersichtScreen
import org.example.project.screens_sys.SysBuildJournalScreen
import org.example.project.screens_sys.SysNodeAuskunftScreen
import org.example.project.screens_sys.SYSSupportAuskunft
import org.example.project.engineservice.cr.SysCRScreen
import org.example.project.screens_sys.SysDashboardAuskunftScreen
import org.example.project.screens_sys.SysZweiFaktorVerwaltung
import org.example.project.screens_sys.SysWebseitenUebersicht
import org.example.project.screens_sys.SysWebseitenWiederkehrer
import org.example.project.screens_sys.SysWebseitenDashboard
import org.example.project.engineservice.support.SysSupportScreen
import org.example.project.cleaning.SysTextToPdfScreen
import org.example.project.screens_sys.SysTerminauskunft
import org.example.project.screens_sys.Unternehmenstamm
import org.example.project.screens_sys.unternehmenstammKarteiPages
import org.example.project.utils.All
import org.example.project.yard.AuftraegeDashboardScreen
import org.example.project.yard.LeitstandHofScreen
import org.example.project.yard.SnapHofuebersichtScreen
import org.example.project.yard.SnapAuftragsDashboardScreen
import org.example.project.yard.StandortLayoutVerwaltung
import org.example.project.yard.WAAuskunftScreen
import org.example.project.yard.WEAuskunftScreen
import org.example.project.yard.WEWebKontrolleAuskunftScreen
import org.example.project.yard.WarenausgangVorbereitungScreen

object DashboardNode {
    const val CUS = "CUS"
    const val SYS = "SYS"
    const val NET = "NET"
    const val CUS_MOBILE = "CUS_MOBILE"
    const val SYS_MOBILE = "SYS_MOBILE"
}

object ScreenMode {
    const val CONTENT = "content"
    const val POPUP = "popup"
}

object SidebarMode {
    const val CATEGORIZED = "CATEGORIZED"
    const val FLAT = "FLAT"
}

private const val SCREEN_CATEGORY_KEY = "dashboardCategory"

private fun dashboardQueryParams(): Map<String, String> {
    val query = window.location.hash.substringAfter('?', "")
    if (query.isBlank()) return emptyMap()
    return query
        .split("&")
        .mapNotNull { entry ->
            val key = entry.substringBefore("=").trim()
            if (key.isBlank()) return@mapNotNull null
            key to (js("decodeURIComponent")(entry.substringAfter("=", "")) as String)
        }
        .toMap()
}

object ScreenManager {
    private val dashboardChildren = mapOf(
        "Modul Shop" to listOf("MeineModule"),
        "SnapMeineAuftraegeDashboard" to listOf("SnapAuftragsDashboard", "MeineSlotAuftraege", "MeineFahrerAuftraege", "EndToEndFlowScreen"),
        "DispoDashboard" to listOf("PALDashboard", "PALVerarbeitung", "PALAuskunft", "PALJournal", "PALDifferenzen"),
        "InfrastrukturDashboard" to listOf("LhmTypVerwaltung", "PalettenTypVerwaltung", "PalettenArtenVerwaltung", "KontrollVerwaltung", "ParkplatzTorverwaltung", "WAPlatzTorverwaltung", "WETorfreigabeScreen"),
        "InfrageneratorDashboard" to listOf("Infrastrukturverwaltung", "TorAuskunft", "PlatzAuskunft", "WAPlatzAuskunft", "ParkplatzAuskunft"),
        "HofDashboard" to listOf("LeitstandHofScreen", "WarenausgangVorbereitungScreen", "RegalUebersicht", "TorUebersicht", "WAPlatzUebersicht", "AuftraegeDashboardScreen"),
        "ZeitfensterDashboard" to listOf("SlotSetup", "SlotView", "LhmTypVerwaltung", "MeineZugmaschienen", "MeineAuflieger"),
        "FinanzenDashboard" to listOf("FinanzDashboard", "Eingangsrechnungen", "Rechnungsuebersicht", "Betriebsausgaben", "FinanzamtQuartale", "Abgabeeinstellungen"),
        "BuildDashboard" to listOf("SystemBuild", "SystemBuildUebersicht", "SystemBuildJournal", "SystemNodeAuskunft"),
        "KundenDashboard" to listOf("Firmenregister", "KunenSetup", "Kundenabrechnung", "Terminauskunft"),
        "WebseitenDashboard" to listOf("WebseitenUebersicht", "WebseitenWiederkehrer"),
        "VertriebsDashboard" to listOf(
            "Vertriebsindex",
            "Konkurrenzindex",
            "Vertriebspool",
            "MeineLeads",
            "Leaduebersicht",
            "LinkedInFlow"
        ),
        "SYSVertriebsDashboard" to listOf(
            "Vertriebsindex", "Konkurrenzindex", "Vertriebspool", "MeineLeads", "Leaduebersicht",
            "LinkedInChat", "LinkedInFlow"
        )
    )

    fun childScreensForKey(key: String, node: String = DashboardNode.SYS): List<All> = dashboardChildren[key].orEmpty()
        .filter { isScreenAllowed(it, node) }
        .map { screenMetaByKey(it).copy(art = resolvedArt(node), bereich = node) }

    fun isCusNavigationDashboard(key: String): Boolean =
        key == "DispoDashboard" || key == "InfrastrukturDashboard" || key == "InfrageneratorDashboard" || key == "HofDashboard" || key == "ZeitfensterDashboard" || key == "SnapMeineAuftraegeDashboard" || key == "VertriebsDashboard"
    private fun screenKey(
        key: String,
        label: String,
        icon: String,
        content: (@Composable (All) -> Unit)? = null,
        karteiPages: List<All> = emptyList(),
        popupMinWidthPx: Int = 720,
        popupMinHeightPx: Int = 520,
        verwaltungsLabel: String
    ): All = All(
        key = key,
        label = label,
        verwaltungsLabel = verwaltungsLabel,
        icon = icon,
        module = karteiPages,
        popupMinWidthPx = popupMinWidthPx,
        popupMinHeightPx = popupMinHeightPx,
        content = content
    )

    private fun category(name: String, icon: String, keys: List<String>) =
        All(bezeichnung = name, icon = icon, columns = keys)

    private fun dashboardBlock(
        node: String,
        sidebarMode: String,
        categories: List<All>
    ) = All(
        key = node,
        typ = sidebarMode,
        module = categories,
        categoryIcons = categories.associate { it.bezeichnung to it.icon }
    )

    private val screenKeyIndex = mapOf(
        "SnapMeineAuftraegeDashboard" to screenKey("SnapMeineAuftraegeDashboard", "SNAP Aufträge", "images/order.svg", { screen -> SHAREDSnapAuftraegeDashboard(screen.bereich) }, verwaltungsLabel = "SNAP Aufträge Dashboard"),
        "DispoDashboard" to screenKey("DispoDashboard", "Palettenkonto", "images/palauskunft.svg", { screen -> CusDispoDashboard(screen.bereich) }, verwaltungsLabel = "Palettenkonto Dashboard"),
        "InfrastrukturDashboard" to screenKey("InfrastrukturDashboard", "Lager Setup", "images/lager.svg", { CusInfrastrukturDashboard() }, verwaltungsLabel = "Lager Setup Dashboard"),
        "InfrageneratorDashboard" to screenKey("InfrageneratorDashboard", "Infragenerator", "images/lager.svg", { CusInfrageneratorDashboard() }, verwaltungsLabel = "Infragenerator Dashboard"),
        "HofDashboard" to screenKey("HofDashboard", "Übersichten", "images/lager.svg", { CusHofDashboard() }, verwaltungsLabel = "Übersichten Dashboard"),
        "ZeitfensterDashboard" to screenKey("ZeitfensterDashboard", "Zeitfenster", "images/slotverwaltung.svg", { screen -> CusZeitfensterDashboard(screen.bereich) }, verwaltungsLabel = "Zeitfenster Dashboard"),
        "NotepadSystem"                  to screenKey("NotepadSystem",                  "Notizen",                "images/note.svg",                    { screen -> SHAREDNotitzen(screen.art, showLauncher = true) }, verwaltungsLabel = "Notizen"),
        "MobileNotepadSystem"            to screenKey("MobileNotepadSystem",            "Notizen",                "images/note.svg",                    { screen -> MobileNotepadLayout(screen.art) }, verwaltungsLabel = "Mobile Notizen"),
        "Fokus"                          to screenKey("Fokus",                          "Fokus",                  "images/fokus.svg",                   {
            Iframe(attrs = {
                attr("srcdoc", decodedFocus2Html())
                attr("title", "Fokus")
                style {
                    width(100.percent)
                    height(100.percent)
                    border(0.px)
                }
            })
        }, verwaltungsLabel = "Fokus"),
        "NodeUebersicht"                 to screenKey("NodeUebersicht",                 "Serverübersicht",        "images/node.svg",                    { ServerUebersicht() }, verwaltungsLabel = "Serverübersicht"),
        "SystemBuild"                    to screenKey("SystemBuild",                    "System Build",           "images/node.svg",                    { SysSystemBuildScreen() }, verwaltungsLabel = "System Build"),
        "BuildDashboard"                 to screenKey("BuildDashboard",                 "System Build",           "images/node.svg",                    { SysBuildDashboard() }, verwaltungsLabel = "Build Dashboard"),
        "SystemBuildUebersicht"          to screenKey("SystemBuildUebersicht",          "Buildübersicht",         "images/node.svg",                    { SysBuildUebersichtScreen() }, verwaltungsLabel = "Buildübersicht"),
        "SystemBuildJournal"             to screenKey("SystemBuildJournal",             "Build-Journal",          "images/info.svg",                    { SysBuildJournalScreen() }, verwaltungsLabel = "Build-Journal"),
        "SystemNodeAuskunft"             to screenKey("SystemNodeAuskunft",             "Node-Auskunft",          "images/node.svg",                    { SysNodeAuskunftScreen() }, verwaltungsLabel = "Node-Auskunft"),
        "Kalender"                       to screenKey("Kalender",                       "Termine",                "images/kalender.svg",                { screen ->
            SHAREDTerminverwaltung(
                art = screen.art,
                node = screen.bereich
            )
        }, verwaltungsLabel = "Terminverwaltung"),
        "AufgabenKalender"               to screenKey("AufgabenKalender",               "Aufgaben",              "images/aufgaben.svg",                { screen ->
            SHAREDAufgabenverwaltung(
                art = screen.art,
                node = screen.bereich
            )
        }, verwaltungsLabel = "Aufgaben"),
        "KontaktKalender"                to screenKey("KontaktKalender",                "Kontakte Kalender",      "images/kalender.svg",                { screen ->
            val params = dashboardQueryParams()
            val sourceUserId = params["userId"]?.takeIf { it.isNotBlank() }
            val sourceFirmenId = params["firmenId"].orEmpty()
            val contextKey = buildString {
                append(screen.key)
                append("#")
                append(sourceFirmenId.ifBlank { "self" })
                append("#")
                append(sourceUserId?.ifBlank { "self" } ?: "self")
            }
            key(contextKey) {
                SHAREDTerminverwaltung(
                    art = screen.art,
                    node = screen.bereich,
                    sourceUserId = sourceUserId,
                    sourceFirmenId = sourceFirmenId
                )
            }
        }, verwaltungsLabel = "Kontakte Kalender"),
        "MeinProfilScreen"               to screenKey("MeinProfilScreen",               "Profil",                 "images/profile.svg",                 { DashboardProfil() }, karteiPages = dashboardProfilKarteiPages, verwaltungsLabel = "Mein Profil"),
        "ChatModuleScreen"               to screenKey("ChatModuleScreen",               "Chat",                   "images/chat.svg",                    content = { ChatModuleScreen() }, popupMinWidthPx = 220, popupMinHeightPx = 160, verwaltungsLabel = "Chat"),
        "CRErstellung"                   to screenKey("CRErstellung",                   "CR Aufträge",                     "images/cr.svg",                      { CUSCRErstellung() }, verwaltungsLabel = "CR Aufträge"),
        "SupportFlowScreen"              to screenKey("SupportFlowScreen",              "Support",                "images/support.svg",                 { screen -> CUSSupportFlow(node = screen.bereich, nodeScreens = allScreenKeys(screen.bereich)) }, verwaltungsLabel = "Support Flow"),
        "SchulungsFlowScreen"            to screenKey("SchulungsFlowScreen",            "KI-Schulung",            "images/kalender.svg",                { SchulungsFlow() }, verwaltungsLabel = "Schulungs Flow"),
        "SchulungsAuskunft"              to screenKey("SchulungsAuskunft",              "Schulungsübersicht",     "images/kalender.svg",                { SchulungsAuskunft() }, verwaltungsLabel = "Schulungsübersicht"),
        "Schulungsverwaltung"            to screenKey("Schulungsverwaltung",            "Schulungsverwaltung",    "images/kalender.svg",                { Schulungsverwaltung() }, verwaltungsLabel = "Schulungsverwaltung"),
        "MitarbeiterKalender"            to screenKey("MitarbeiterKalender",            "Kalender",                "images/kalender.svg",                { MitarbeiterKalender() }, verwaltungsLabel = "Mein Kalender"),
        "AufgabenViewer"                 to screenKey("AufgabenViewer",                 "Aufgaben",               "images/aufgaben.svg",                 { AufgabenViewerScreen() }, verwaltungsLabel = "Aufgaben"),
        "MitarbeiterMeinUrlaub"          to screenKey("MitarbeiterMeinUrlaub",          "Mein Urlaub",             "images/urlaub.svg",                  { MitarbeiterMeinUrlaub() }, verwaltungsLabel = "Mein Urlaub"),
        "MitarbeiterZeitkonto"           to screenKey("MitarbeiterZeitkonto",           "Zeitkonto",               "images/zeitkonto.svg",                { MitarbeiterZeitkonto() }, verwaltungsLabel = "MA Zeitkonto"),
        "Zeiterfassung"                  to screenKey("Zeiterfassung",                  "Zeiterfassung",           "images/zeiterfassung.svg",           { MobileArbeitszeiterfassung() }, verwaltungsLabel = "Zeiterfassung"),
        "Arbeitszeitverwaltung"          to screenKey("Arbeitszeitverwaltung",          "Anwesenheit",              "images/kalender.svg",                { screen -> AnwesenheitsverwaltungScreen(screen.art) }, verwaltungsLabel = "Anwesenheits Dashboard"),
        "Buchungsjournal"                to screenKey("Buchungsjournal",                "Buchungsjournal",         "images/kalender.svg",                { screen -> BuchungsjournalScreen(screen.art) }, verwaltungsLabel = "Arbeitszeitjournal"),
        "Personalverwaltung"                   to screenKey("Personalverwaltung",                   "Personalverwaltung",            "images/user.svg",                    { screen -> PersonalverwaltungScreen(screen.art) }, verwaltungsLabel = "Personalverwaltung"),
        "Urlaubsuebersicht"              to screenKey("Urlaubsuebersicht",              "Abwesenheitsübersicht",   "images/kalender.svg",                { screen -> CUSUrlaubsuebersicht(screen.art) }, verwaltungsLabel = "Abwesenheitsübersicht"),
        "Zeitverwaltung"                 to screenKey("Zeitverwaltung",                 "Zeitübersicht",           "images/kalender.svg",                { screen -> CUSZeitverwaltung(screen.art) }, verwaltungsLabel = "Zeitübersicht"),
        "Stempeluhr"                     to screenKey("Stempeluhr",                     "Stempeluhr",              "images/stempeluhr.svg",              { StempeluhrScreen() }, verwaltungsLabel = "Stempeluhr"),
        "StempeluhrGenerator"            to screenKey("StempeluhrGenerator",            "Stempeluhr Generator",    "images/qr.svg",                      { StempeluhrGeneratorScreen() }, verwaltungsLabel = "Stempeluhr Generator"),
        "Stempelkarte"                   to screenKey("Stempelkarte",                   "Stempelkarte",            "images/qr.svg",                      { StempelkarteScreen() }, verwaltungsLabel = "Stempelkarte"),
        "TorUebersicht"                  to screenKey("TorUebersicht",                  "Torübersicht",           "images/toruebersicht.svg",           { CUSTorUebersicht() }, verwaltungsLabel = "Torübersicht"),
        "RegalUebersicht"                to screenKey("RegalUebersicht",                "Regalübersicht",         "images/regaluebersicht.svg",         { CUSRegaluebersicht() }, verwaltungsLabel = "Regalübersicht"),
        "WAPlatzUebersicht"              to screenKey("WAPlatzUebersicht",              "WA Platz Übersicht",     "images/wavorbereitung.svg",          { CUSWAPlatzUebersicht() }, verwaltungsLabel = "WA Platz Übersicht"),
        "WarenausgangVorbereitungScreen" to screenKey("WarenausgangVorbereitungScreen", "Auftragsübersicht",      "images/wavorbereitung.svg",          { WarenausgangVorbereitungScreen() }, verwaltungsLabel = "Auftragsübersicht"),
        "LeitstandHofScreen"             to screenKey("LeitstandHofScreen",             "Hofübersicht",           "images/lager.svg",                   { LeitstandHofScreen() }, verwaltungsLabel = "Hofübersicht"),
        "SnapHofuebersicht"              to screenKey("SnapHofuebersicht",              "Snap Hofübersicht",      "images/lager.svg",                   { SnapHofuebersichtScreen() }, verwaltungsLabel = "Snap Hofübersicht"),
        "AuftraegeDashboardScreen"        to screenKey("AuftraegeDashboardScreen",        "Aufträge Dashboard",     "images/order.svg",                   { AuftraegeDashboardScreen() }, verwaltungsLabel = "Aufträge Dashboard"),
        "SnapAuftragsDashboard"           to screenKey("SnapAuftragsDashboard",           "Snap Aufträge",          "images/order.svg",                   { SnapAuftragsDashboardScreen() }, verwaltungsLabel = "Snap Aufträge"),
        "EndToEndFlowScreen"              to screenKey("EndToEndFlowScreen",              "End-to-End",             "images/end_to_end_flow.svg",         { screen -> SHAREDEndToEndFlow(screen.art) }, verwaltungsLabel = "Yard End-to-End"),
        "WEAuskunftScreen"               to screenKey("WEAuskunftScreen",               "WE Auskunft",            "images/we.svg",                      { WEAuskunftScreen() }, verwaltungsLabel = "WE Auskunft"),
        "WEWebKontrolleAuskunftScreen"    to screenKey("WEWebKontrolleAuskunftScreen",    "WE Fehlerprotokoll",     "images/inventory.svg",               { WEWebKontrolleAuskunftScreen() }, verwaltungsLabel = "WE-Fehlerprotokoll"),
        "WAAuskunftScreen"               to screenKey("WAAuskunftScreen",               "WA Auskunft",            "images/wa.svg",                      { WAAuskunftScreen() }, verwaltungsLabel = "WA Auskunft"),
        "Snapverwaltung"                 to screenKey("Snapverwaltung",                 "Snapverwaltung",         "images/domain.svg",                  { CUSSnapverwaltung() }, verwaltungsLabel = "Snapverwaltung"),
        "UserVerwaltung"             to screenKey("UserVerwaltung",             "Benutzerverwaltung", "images/userverwaltung.svg",      { screen -> SHAREDUserverwaltung(screen.art) }, karteiPages = userverwaltungKarteiPages, verwaltungsLabel = "Benutzerverwaltung"),
        "UserVerwaltungTabelle"      to screenKey("UserVerwaltungTabelle",      "Benutzer Tabelle",   "images/userverwaltung.svg",      { screen -> SHAREDUserverwaltungTabelle(screen.art) }, verwaltungsLabel = "Benutzer Tabelle"),
        "ServiceBuchen"                  to screenKey("ServiceBuchen",                  "Service Buchen",         "images/kalender.svg",                { screen -> SHAREDTerminverwaltung(screen.art, screen.bereich, sourceArt = NodeScope.SYS, sourceUserId = "1", sourceFirmenId = "ls1000", serviceBookingMode = true) }, verwaltungsLabel = "Lumatica Service"),
        "LoginJournal"                   to screenKey("LoginJournal",                   "Login Auskunft",         "images/loginjournal.svg",            { SHAREDLoginauskunft() }, verwaltungsLabel = "Login Auskunft"),
        "KontrollVerwaltung"             to screenKey("KontrollVerwaltung",             "Kontroll Einstellungen", "images/kontrolldefinitionen.svg",    { CUSKontrollverwaltung() }, verwaltungsLabel = "Kontroll Einstellungen"),
        "Infrastrukturverwaltung"        to screenKey("Infrastrukturverwaltung",        "Infrastruktur",          "images/lager.svg",                   { CUSInfrastrukturverwaltung() }, verwaltungsLabel = "Yard Infrastruktur"),
        "PalettenTypVerwaltung"          to screenKey("PalettenTypVerwaltung",          "Modul Typen",            "images/lhmtyp.svg",                  { CUSPalettenTypverwaltung() }, verwaltungsLabel = "Modul Typen"),
        "WAPlatzTorverwaltung"           to screenKey("WAPlatzTorverwaltung",           "Platz & Tor",            "images/wavorbereitung.svg",          { CUSWAPlatzTorverwaltung() }, verwaltungsLabel = "Platz & Tor"),
        "ParkplatzTorverwaltung"         to screenKey("ParkplatzTorverwaltung",         "Parkplatz & Tor",        "images/toruebersicht.svg",           { CUSParkplatzTorverwaltung() }, verwaltungsLabel = "Parkplatz & Tor"),
        "WETorfreigabeScreen"            to screenKey("WETorfreigabeScreen",            "WE Torfreigabe",         "images/we.svg",                      { CUSWETorfreigabeScreen() }, verwaltungsLabel = "WE Torfreigabe"),
        "Unternehmenstamm"               to screenKey("Unternehmenstamm",               "Unternehmen",            "images/domain.svg",                  { Unternehmenstamm() }, karteiPages = unternehmenstammKarteiPages, verwaltungsLabel = "Unternehmen"),
        "StandortVerwaltung"             to screenKey("StandortVerwaltung",             "Standorte",              "images/domain.svg",                  { CUSStandortverwaltung() }, karteiPages = standortverwaltungKarteiPages, verwaltungsLabel = "Standorte"),
        "NetStandortVerwaltung"          to screenKey("NetStandortVerwaltung",          "Standorte",              "images/domain.svg",                  { NETStandortverwaltung() }, karteiPages = netstandortverwaltungKarteiPages, verwaltungsLabel = "NET Standorte"),
        "SlotView"                       to screenKey("SlotView",                       "Zeitfensterübersicht",   "images/slotview.svg",                { screen -> SlotView(screen.art) }, verwaltungsLabel = "Slot Zeitfensterübersicht"),
        "MeineSlotAuftraege"             to screenKey("MeineSlotAuftraege",             "Meine Aufträge",         "images/order.svg",                   { screen -> SHAREDMeineSlotAuftraege(screen.art) }, verwaltungsLabel = "Meine Aufträge"),
        "MeineFahrerAuftraege"           to screenKey("MeineFahrerAuftraege",           "Meine Fahrer Aufträge",  "images/user.svg",                    { screen -> SHAREDMeineFahrerAuftraege(screen.art) }, verwaltungsLabel = "Meine Fahrer Aufträge"),
        "SlotSetup"                      to screenKey("SlotSetup",                      "Zeitfensterbuchung",     "images/sloteditor.svg",              { screen -> SlotSetup(screen.art) }, verwaltungsLabel = "Slot Zeitfensterbuchung"),
        "LhmTypVerwaltung"               to screenKey("LhmTypVerwaltung",               "LHM Typen",              "images/lhmtypen.svg",                { CUSLhmTypverwaltung() }, verwaltungsLabel = "LHM Typen"),
        "MeineZugmaschienen"             to screenKey("MeineZugmaschienen",             "Meine Zugmaschienen",    "images/lkw.svg",                     { screen -> SHAREDMeineZugmaschienen(screen.art) }, verwaltungsLabel = "Meine Zugmaschienen"),
        "MeineAuflieger"                 to screenKey("MeineAuflieger",                 "Meine Auflieger",        "images/lkw.svg",                     { screen -> SHAREDMeineAuflieger(screen.art) }, verwaltungsLabel = "Meine Auflieger"),
        "TorAuskunft"                    to screenKey("TorAuskunft",                    "Torauskunft",            "images/toruebersicht.svg",           { CUSTorAuskunft() }, verwaltungsLabel = "Torauskunft"),
        "ParkplatzAuskunft"              to screenKey("ParkplatzAuskunft",              "Parkplatzauskunft",      "images/info.svg",                    { CUSParkplatzAuskunft() }, verwaltungsLabel = "Parkplatzauskunft"),
        "PalettenArtenVerwaltung"        to screenKey("PalettenArtenVerwaltung",        "Paletten Arten",         "images/palauskunft.svg",             { CUSPalettenArtenVerwaltung() }, verwaltungsLabel = "Paletten Arten"),
        "PALDashboard"                   to screenKey("PALDashboard",                   "Palettenkonto Dashboard","images/palauskunft.svg",             { PalDashboardScreen() }, verwaltungsLabel = "Palettenkonto Dashboard"),
        "PALVerarbeitung"                to screenKey("PALVerarbeitung",                "Palettenkonto",          "images/palauskunft.svg",             { PalVerarbeitungScreen() }, verwaltungsLabel = "Palettenkonto"),
        "PALJournal"                     to screenKey("PALJournal",                     "Palettenkonto Journal",  "images/palauskunft.svg",             { PalJournalScreen() }, verwaltungsLabel = "Palettenkonto Journal"),
        "PALAuskunft"                    to screenKey("PALAuskunft",                    "Palettenkonto Auskunft", "images/palauskunft.svg",             { PalAuskunftScreen() }, verwaltungsLabel = "Palettenkonto Auskunft"),
        "PALDifferenzen"                 to screenKey("PALDifferenzen",                 "Palettenkonto Klärung",  "images/palauskunft.svg",             { PalDifferenzenScreen() }, verwaltungsLabel = "Palettenkonto Klärung"),
        "StandortLayoutVerwaltung"       to screenKey("StandortLayoutVerwaltung",       "Standort Layout",        "images/setup.svg",                   { StandortLayoutVerwaltung() }, verwaltungsLabel = "Standort Layout"),
        "PlatzAuskunft"                  to screenKey("PlatzAuskunft",                  "Platz Auskunft",         "images/info.svg",                    { CUSPlatzAuskunft() }, verwaltungsLabel = "Platz Auskunft"),
        "WAPlatzAuskunft"                to screenKey("WAPlatzAuskunft",                "WA Platz Auskunft",      "images/wavorbereitung.svg",          { CUSWAPlatzAuskunft() }, verwaltungsLabel = "WA Platz Auskunft"),
        "Modul Shop"                     to screenKey("Modul Shop",                     "Modul Shop",             "images/modulshop.svg",               { ModulShopLayout(syncToHash = false) }, verwaltungsLabel = "Modul Shop"),
        "MeineModule"                    to screenKey("MeineModule",                    "Meine Module",           "images/box.svg",                     { ModulShop(viewMode = ModulShopViewMode.MINE, showHeaderTabs = false, showFeaturedHero = false) }, verwaltungsLabel = "Meine Module"),
        "DashboardSmartRing"             to screenKey("DashboardSmartRing",             "Smart Ring",             "images/smartring.svg",               { screen -> EngineSmartRingScreen(screen.bereich.ifBlank { DashboardNode.SYS }) }, verwaltungsLabel = "Smart Ring"),
        "ScreenAnzeigeModus"             to screenKey("ScreenAnzeigeModus",             "Screen Verwaltung",      "images/screenverwaltung.svg",        { DashboardAnzeigeArt() }, verwaltungsLabel = "Screen Verwaltung"),
        "ScreenUmgebungen"               to screenKey("ScreenUmgebungen",               "Screen-Umgebungen",      "images/screenverwaltung.svg",        { DashboardScreenUmgebungen() }, verwaltungsLabel = "Screen-Umgebungen"),
        "MobileAnsichten"                 to screenKey("MobileAnsichten",                 "Mobile-Ansichten",       "images/apps.svg",                     { screen -> DashboardMobileAnsichten(screen.art) }, verwaltungsLabel = "Mobile-Screen-Zuordnung"),
        "FeedControlScreen"              to screenKey("FeedControlScreen",              "Feed Control",           "images/dashboardauskunft.svg",       { SysFeedControlScreen() }, verwaltungsLabel = "Feed Control"),
       "KarteiSeitenVerwaltungScreen"   to screenKey("KarteiSeitenVerwaltungScreen",   "Kartei Settings",        "images/karteisettings.svg",          { screen -> SHAREDKarteiSettings(screen.art) }, verwaltungsLabel = "Kartei Settings"),
        "YardSettingsScreen"              to screenKey("YardSettingsScreen",              "Yard Settings",          "images/einstellungen.svg",           { screen -> SHAREDYardSettings(screen.art) }, verwaltungsLabel = "Yard Settings"),
        "ZweiFaktorVerwaltung"           to screenKey("ZweiFaktorVerwaltung",           "2F Browser-Freigaben",   "images/einstellungen.svg",           { SysZweiFaktorVerwaltung() }, verwaltungsLabel = "2F Browser-Freigaben"),
        "RollenVerwaltung"               to screenKey("RollenVerwaltung",               "Rollen",                 "images/role.svg",                    { screen -> SHAREDRollenverwaltung(screen.art) }, verwaltungsLabel = "Rollen"),
        "BereichsVerwaltung"             to screenKey("BereichsVerwaltung",             "Bereiche",               "images/domain.svg",                  { screen -> SHAREDBereichsverwaltung(screen.art) }, verwaltungsLabel = "Bereiche"),
        "CUSSupportAuskunft"             to screenKey("CUSSupportAuskunft",             "Support Auskunft",       "images/supportauskunft.svg",         { CUSSupportAuskunft() }, verwaltungsLabel = "Support Auskunft"),
        "CUSCRAuskunft"                  to screenKey("CUSCRAuskunft",                  "CR Auskunft",            "images/crinfo.svg",                  { CUSCRAuskunft() }, verwaltungsLabel = "CR Auskunft"),
        "SupportAuskunftScreen"          to screenKey("SupportAuskunftScreen",          "Support Auskunft",       "images/supportauskunft.svg",         { SYSSupportAuskunft() }, verwaltungsLabel = "SYS Support Auskunft"),
        "SYSSupportScreen"               to screenKey("SYSSupportScreen",               "Support",                "images/support.svg",                 { SysSupportScreen() }, verwaltungsLabel = "SYS Support"),
        "SYSCRScreen"                    to screenKey("SYSCRScreen",                    "CR Bearbeitung",         "images/cr.svg",                      { SysCRScreen() }, verwaltungsLabel = "CR Bearbeitung"),
        "CRAuskunft"                     to screenKey("CRAuskunft",                     "CR Auskunft",            "images/crinfo.svg",                  { SYSCRAuskunft() }, verwaltungsLabel = "SYS CR-Auskunft"),
        "KunenSetup"                     to screenKey("KunenSetup",                     "Kunden Setup",           "images/kundensetup.svg",             { Kundensetup() }, verwaltungsLabel = "Kunden Setup"),
        "KundenDashboard"                to screenKey("KundenDashboard",                "Kunden",                 "images/domain.svg",                  { SysKundenDashboard() }, verwaltungsLabel = "Kunden Dashboard"),
        "VertriebsDashboard" to screenKey("VertriebsDashboard", "Vertriebs-Dashboard", "images/domain.svg", { screen -> VertriebsDashboard(screen.bereich) }, verwaltungsLabel = "Vertriebs-Dashboard"),
        "SYSVertriebsDashboard" to screenKey("SYSVertriebsDashboard", "Vertriebsdashboard", "images/domain.svg", { screen -> SysVertriebsDashboard(screen.bereich) }, verwaltungsLabel = "Vertriebsdashboard SYS"),
        "Vertriebspool" to screenKey("Vertriebspool", "Vertriebspool", "images/kundenstammdaten.svg", { Vertriebspool() }, verwaltungsLabel = "Vertriebspool"),
        "MeineLeads" to screenKey("MeineLeads", "Meine Leads", "images/kundenstammdaten.svg", { screen -> MeineLeads(screen.bereich) }, verwaltungsLabel = "Meine Leads"),
        "LinkedInFlow" to screenKey("LinkedInFlow", "Flow", "images/call.svg", { screen -> LinkedInLeadUebernahme(screen.bereich) }, verwaltungsLabel = "Flow"),
        "LinkedInChat" to screenKey("LinkedInChat", "LinkedIn-Chat", "images/linkedin.svg", { screen -> LinkedInChat(screen.bereich) }, verwaltungsLabel = "LinkedIn-Chat"),
        "Vertriebsindex"                 to screenKey("Vertriebsindex",                 "Vertriebsindex",         "images/kundenstammdaten.svg",        { Vertriebsindex() }, verwaltungsLabel = "Vertriebsindex"),
        "Konkurrenzindex" to screenKey("Konkurrenzindex", "Konkurrenzindex", "images/kundenstammdaten.svg", { Konkurrenzindex() }, verwaltungsLabel = "Konkurrenzindex"),
        "Leaduebersicht" to screenKey("Leaduebersicht", "Leadübersicht", "images/kundenstammdaten.svg", { Leaduebersicht() }, verwaltungsLabel = "Leadübersicht"),
        "AkquiseEinstellungen" to screenKey("AkquiseEinstellungen", "Akquise Einstellungen", "images/einstellungen.svg", { screen -> AkquiseEinstellungen(screen.bereich) }, verwaltungsLabel = "Akquise Einstellungen"),
        "Kundenabrechnung"                to screenKey("Kundenabrechnung",                "Kundenabrechnung",        "images/abrechnung.svg",              { Sys_Kundenabrechnung() }, verwaltungsLabel = "Kundenabrechnung"),
        "Rechnungsuebersicht"            to screenKey("Rechnungsuebersicht",            "Ausgangsrechnungen",     "images/abrechnung.svg",              { Sys_Rechnungsuebersicht() }, verwaltungsLabel = "Ausgangsrechnungen"),
        "Betriebsausgaben"               to screenKey("Betriebsausgaben",               "Betriebsausgaben",       "images/abrechnung.svg",              { SysBetriebsausgabenScreen() }, verwaltungsLabel = "Betriebsausgaben"),
        "Eingangsrechnungen"             to screenKey("Eingangsrechnungen",             "Eingangsrechnungen",     "images/abrechnung.svg",              { SysEingangsrechnungenScreen() }, verwaltungsLabel = "Eingangsrechnungen"),
        "FinanzDashboard"                to screenKey("FinanzDashboard",                "Finanzdashboard",        "images/money.svg",                   { SysFinanzDashboardScreen() }, verwaltungsLabel = "Finanzdashboard"),
        "FinanzenDashboard"              to screenKey("FinanzenDashboard",              "Finanzen",               "images/abrechnung.svg",              { SysFinanzWrapper() }, verwaltungsLabel = "Finanzen Dashboard"),
        "FinanzamtQuartale"               to screenKey("FinanzamtQuartale",               "Finanzamt",              "images/abrechnung.svg",              { SysFinanzamtQuartaleScreen() }, verwaltungsLabel = "Finanzamt Quartale"),
        "Abgabeeinstellungen"            to screenKey("Abgabeeinstellungen",            "Abgabeeinstellungen",    "images/settings.svg",                { SysAbgabeeinstellungenScreen() }, verwaltungsLabel = "Abgabeeinstellungen"),
        "Modulauskunft"                  to screenKey("Modulauskunft",                  "Modulauskunft",          "images/modulshop.svg",               { SysModulauskunft() }, verwaltungsLabel = "Modulauskunft"),
        "Terminauskunft"                 to screenKey("Terminauskunft",                 "Terminauskunft",         "images/kalender.svg",                { SysTerminauskunft() }, verwaltungsLabel = "Terminauskunft"),
        "CUSKundenverbrauch"             to screenKey("CUSKundenverbrauch",             "Mein Verbrauch",         "images/auswertung.svg",              { CUSKundenverbrauch() }, verwaltungsLabel = "Mein Verbrauch"),
        "CUSRechnungsuebersicht"         to screenKey("CUSRechnungsuebersicht",         "Rechnungsübersicht",     "images/abrechnung.svg",              { CUSRechnungsuebersicht() }, verwaltungsLabel = "Rechnungsübersicht"),
        "CUSTerminauskunft"              to screenKey("CUSTerminauskunft",              "Termin Auskunft",         "images/kalender.svg",                { CUSTerminauskunft() }, verwaltungsLabel = "Termin Auskunft"),
        "CEODashboard"                   to screenKey("CEODashboard",                   "CEO Dashboard",          "images/ceo.svg",                     { CUSCeoDashboard() }, verwaltungsLabel = "CEO Dashboard"),
        "SystemDashboardScreen"          to screenKey("SystemDashboardScreen",          "System",                 "images/ceo.svg",                     { CUSSystemDashboardScreen() }, verwaltungsLabel = "System Dashboard"),
        "SYSSystemDashboard"             to screenKey("SYSSystemDashboard",             "System",                 "images/ceo.svg",                     { SysSystemDashboard() }, verwaltungsLabel = "SYS System-Dashboard"),
        "SYSDashboardAuskunft"           to screenKey("SYSDashboardAuskunft",           "Dashboard Auskunft",     "images/dashboardauskunft.svg",       { SysDashboardAuskunftScreen() }, verwaltungsLabel = "Dashboard Auskunft"),
        "WebseitenDashboard"             to screenKey("WebseitenDashboard",             "Webseite",               "images/webseitenuebersicht.svg",       { SysWebseitenDashboard() }, verwaltungsLabel = "Webseiten-Dashboard"),
        "WebseitenUebersicht"            to screenKey("WebseitenUebersicht",            "Webseitenübersicht",    "images/webseitenuebersicht.svg",       { SysWebseitenUebersicht() }, verwaltungsLabel = "Webseitenübersicht"),
        "WebseitenWiederkehrer"           to screenKey("WebseitenWiederkehrer",           "Wiederkehrer",          "images/webseitenuebersicht.svg",       { SysWebseitenWiederkehrer() }, verwaltungsLabel = "Wiederkehrende Besucher"),
        "Modul Editor"                   to screenKey("Modul Editor",                   "Modul Editor",           "images/moduleditor.svg",             { ModulEditor() }, verwaltungsLabel = "Modul Editor"),
        "TabularCreator"                 to screenKey("TabularCreator",                 "Tabellen Editor",        "images/tabular.svg",                 { TabularCreator() }, verwaltungsLabel = "Tabellen Editor"),
        "SysTextToPdfScreen"             to screenKey("SysTextToPdfScreen",             "Text to PDF",            "images/pdf.svg",                     { SysTextToPdfScreen() }, verwaltungsLabel = "Text to PDF"),
        "ScreenLizenzVerwaltung"         to screenKey("ScreenLizenzVerwaltung",         "Lizenzierung",           "images/lizensierung.svg",            { LIZMaskenLizenzierung() }, verwaltungsLabel = "Lizenzierung"),
        "Firmenregister"                 to screenKey("Firmenregister",                 "Firmenregister",         "images/firmenregister.svg",          { Firmenregister() }, verwaltungsLabel = "Firmenregister"),
        "MobileWEAuswahlScreen"          to screenKey("MobileWEAuswahlScreen",          "Wareneingang",           "images/we.svg",                      { CUSMobileWEFlowScreen() }, verwaltungsLabel = "Wareneingang"),
        "MobileWEKontrolleScreen"        to screenKey("MobileWEKontrolleScreen",        "WE Fehlerprotokoll",      "images/inventory.svg",               { CUSMobileWEWebKontrolleScreen() }, verwaltungsLabel = "Mobile WE-Fehlererfassung"),
        "MobileWAAuswahlScreen"          to screenKey("MobileWAAuswahlScreen",          "Warenausgang",           "images/wa.svg",                      { CUSMobileWAFlowScreen() }, verwaltungsLabel = "Warenausgang"),
        "MobileWAKontrolleScreen"        to screenKey("MobileWAKontrolleScreen",        "WA Kontrolle",           "images/inventory.svg",               { CUSMobileWAStandortKontrolleScreen() }, verwaltungsLabel = "WA Kontrolle")
    )


    private val sysDesktop = dashboardBlock(
        node = DashboardNode.SYS,
        sidebarMode = SidebarMode.CATEGORIZED,
        categories = listOf(
            category("Dashboards", "images/dashboard.svg", listOf("SYSSystemDashboard", "Arbeitszeitverwaltung", "KundenDashboard", "VertriebsDashboard", "SYSVertriebsDashboard", "BuildDashboard", "FinanzenDashboard", "WebseitenDashboard")),
            category("Lizenzen", "images/lizenzen.svg", listOf("Modul Editor", "ScreenLizenzVerwaltung", "Modulauskunft")),
            category("Systemverwaltung", "images/einstellungen.svg", listOf("NodeUebersicht")),
            category("Stammdaten", "images/stamm.svg", listOf("UserVerwaltung", "UserVerwaltungTabelle")),
            category("Service", "images/support.svg", listOf("SYSSupportScreen", "SupportAuskunftScreen", "SYSCRScreen", "CRAuskunft")),
            category("Schulung", "images/kalender.svg", listOf("Schulungsverwaltung", "SchulungsAuskunft")),
            category("Auskunft", "images/info.svg", listOf("LoginJournal", "SYSDashboardAuskunft")),
            category("Tools", "images/tools.svg", listOf("NotepadSystem", "Kalender", "AufgabenKalender", "ChatModuleScreen", "TabularCreator", "SysTextToPdfScreen", "DashboardSmartRing")),
            category("Einstellungen", "images/einstellungen.svg", listOf("MobileAnsichten", "FeedControlScreen", "ZweiFaktorVerwaltung", "KarteiSeitenVerwaltungScreen", "RollenVerwaltung", "ScreenAnzeigeModus", "ScreenUmgebungen"))
        )
    )



    private val cusDesktop = dashboardBlock(
        node = DashboardNode.CUS,
        sidebarMode = SidebarMode.CATEGORIZED,
        categories = listOf(
            category("Dashboards", "images/dashboard.svg", listOf("DispoDashboard", "InfrastrukturDashboard", "InfrageneratorDashboard", "HofDashboard", "Arbeitszeitverwaltung", "ZeitfensterDashboard", "SnapMeineAuftraegeDashboard", "VertriebsDashboard")),
            category("Auskunft",      "images/auskunft.svg",      listOf("SystemDashboardScreen", "WEAuskunftScreen", "WEWebKontrolleAuskunftScreen", "WAAuskunftScreen", "LoginJournal")),
            category("Stammdaten",    "images/stamm.svg",         listOf("UserVerwaltung", "UserVerwaltungTabelle")),
            category("Snapverwaltung","images/domain.svg",        listOf("Snapverwaltung", "SnapHofuebersicht")),
            category("Tools",         "images/tools.svg",         listOf("NotepadSystem", "Kalender", "AufgabenKalender", "ChatModuleScreen", "Modul Shop", "DashboardSmartRing")),
            category("Einstellungen", "images/einstellungen.svg", listOf("MobileAnsichten", "KarteiSeitenVerwaltungScreen", "YardSettingsScreen", "RollenVerwaltung", "BereichsVerwaltung")),
            category("Support",       "images/support.svg",       listOf("SupportFlowScreen")),
            category("Schulung",      "images/kalender.svg",      listOf("Schulungsverwaltung", "SchulungsAuskunft")),
            category("CEO",           "images/ceo.svg",           listOf("CEODashboard", "CRErstellung", "CUSTerminauskunft", "ServiceBuchen","CUSSupportAuskunft", "CUSCRAuskunft"))
        )
    )


    private val cusMobile = dashboardBlock(
        node = DashboardNode.CUS_MOBILE,
        sidebarMode = SidebarMode.FLAT,
        categories = listOf(
            category("Mobile", "images/apps.svg", listOf("MobileNotepadSystem", "Stempelkarte", "Stempeluhr", "Zeiterfassung", "MitarbeiterKalender", "AufgabenViewer", "MitarbeiterMeinUrlaub", "MitarbeiterZeitkonto", "MobileWEAuswahlScreen", "MobileWEKontrolleScreen", "MobileWAAuswahlScreen", "MobileWAKontrolleScreen", "ChatModuleScreen"))
        )
    )

    private val sysMobile = dashboardBlock(
        node = DashboardNode.SYS_MOBILE,
        sidebarMode = SidebarMode.FLAT,
        categories = listOf(
            category("Mobile", "images/apps.svg", listOf("MobileNotepadSystem", "Fokus", "Stempelkarte", "Stempeluhr", "Zeiterfassung", "MitarbeiterKalender", "AufgabenViewer", "MitarbeiterMeinUrlaub", "MitarbeiterZeitkonto", "SysTextToPdfScreen", "ChatModuleScreen"))
        )
    )

    private val netDesktop = dashboardBlock(
        node = DashboardNode.NET,
        sidebarMode = SidebarMode.CATEGORIZED,
        categories = listOf(
            category("Dashboards", "images/dashboard.svg", listOf("SnapMeineAuftraegeDashboard", "DispoDashboard", "ZeitfensterDashboard")),
            category("Netzwerk", "images/domain.svg", listOf("Snapverwaltung", "SnapHofuebersicht")),
            category("Tools", "images/tools.svg", listOf("ChatModuleScreen", "Kalender", "AufgabenKalender", "NotepadSystem", )),
            category("Stammdaten", "images/einstellungen.svg", listOf("UserVerwaltung", "UserVerwaltungTabelle")),
            category("Support", "images/support.svg", listOf("SupportFlowScreen", "CUSSupportAuskunft"))
        )
    )

    private val dashboardBlocks = mapOf(
        DashboardNode.SYS to sysDesktop,
        DashboardNode.CUS to cusDesktop,
        DashboardNode.CUS_MOBILE to cusMobile,
        DashboardNode.SYS_MOBILE to sysMobile,
        DashboardNode.NET to netDesktop
    )

    private val supportedActionsByScreen = mapOf(
        "SnapMeineAuftraegeDashboard" to setOf("READ"),
        "DispoDashboard" to setOf("READ"),
        "InfrastrukturDashboard" to setOf("READ"),
        "InfrageneratorDashboard" to setOf("READ"),
        "HofDashboard" to setOf("READ"),
        "ZeitfensterDashboard" to setOf("READ"),
        "SystemBuild" to setOf("READ", "WRITE", "SAVE", "INSTALL"),
        "BuildDashboard" to setOf("READ"),
        "SystemBuildUebersicht" to setOf("READ", "EXPORT"),
        "SystemBuildJournal" to setOf("READ", "EXPORT"),
        "SystemNodeAuskunft" to setOf("READ", "EXPORT"),
        "NotepadSystem" to setOf("READ", "WRITE"),
        "MobileNotepadSystem" to setOf("READ", "WRITE"),
        "NodeUebersicht" to setOf("READ"),
        "Kalender" to setOf("READ", "EDIT", "SAVE", "SETTINGS"),
        "AufgabenKalender" to setOf("READ", "EDIT", "SAVE", "SETTINGS"),
        "KontaktKalender" to setOf("READ", "EDIT", "SAVE", "SETTINGS"),
        "ChatModuleScreen" to setOf("READ", "WRITE"),
        "CRErstellung" to setOf("READ", "WRITE"),
        "SupportFlowScreen" to setOf("READ", "WRITE"),
        "SchulungsFlowScreen" to setOf("READ", "WRITE"),
        "SchulungsAuskunft" to setOf("READ", "EXPORT", "SETTINGS"),
        "Schulungsverwaltung" to setOf("READ", "WRITE", "SAVE", "CREATE", "DELETE", "SETTINGS"),
        "MitarbeiterKalender" to setOf("READ", "WRITE"),
        "AufgabenViewer" to setOf("READ"),
        "MitarbeiterMeinUrlaub" to setOf("READ", "WRITE", "SAVE"),
        "MitarbeiterZeitkonto" to setOf("READ"),
        "Zeiterfassung" to setOf("READ", "WRITE", "SAVE"),
        "Arbeitszeitverwaltung" to setOf("READ", "EDIT", "WRITE", "SAVE", "CREATE", "APPROVE", "CANCEL", "EXPORT", "SETTINGS"),
        "Buchungsjournal" to setOf("READ", "WRITE", "SAVE", "EXPORT", "SETTINGS"),
        "Personalverwaltung" to setOf("READ", "EDIT", "SAVE", "CREATE"),
        "Urlaubsuebersicht" to setOf("READ", "WRITE", "SAVE", "APPROVE", "IMPORT", "EXPORT", "SETTINGS"),
        "Zeitverwaltung" to setOf("READ", "EDIT", "SAVE", "CREATE", "SETTINGS"),
        "Stempeluhr" to setOf("READ", "WRITE", "SAVE"),
        "StempeluhrGenerator" to setOf("READ", "WRITE", "SAVE", "CREATE", "DELETE", "SETTINGS"),
        "Stempelkarte" to setOf("READ"),
        "TorUebersicht" to setOf("READ", "EDIT", "SAVE", "SETTINGS"),
        "RegalUebersicht" to setOf("READ", "SAVE", "SETTINGS"),
        "WAPlatzUebersicht" to setOf("READ"),
        "WarenausgangVorbereitungScreen" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "IMPORT", "EXPORT", "SETTINGS", "APPROVE"),
        "LeitstandHofScreen" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "IMPORT", "EXPORT", "SETTINGS"),
        "SnapHofuebersicht" to setOf("READ", "EDIT", "SAVE", "SETTINGS"),
        "AuftraegeDashboardScreen" to setOf("READ", "EXPORT", "SETTINGS"),
        "SnapAuftragsDashboard" to setOf("READ", "EXPORT", "SETTINGS"),
        "EndToEndFlowScreen" to setOf("READ", "EXPORT", "SETTINGS"),
        "WEAuskunftScreen" to setOf("READ", "EXPORT", "SETTINGS"),
        "WEWebKontrolleAuskunftScreen" to setOf("READ", "EXPORT", "SETTINGS"),
        "WAAuskunftScreen" to setOf("READ", "EXPORT", "SETTINGS"),
        "Snapverwaltung" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "IMPORT", "EXPORT", "SETTINGS"),
        "UserVerwaltung" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "IMPORT", "EXPORT", "SETTINGS", "PASSWORD"),
        "UserVerwaltungTabelle" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "IMPORT", "EXPORT", "SETTINGS", "PASSWORD"),
        "MeinProfilScreen" to setOf("READ", "WRITE", "SAVE"),
        "ServiceBuchen" to setOf("READ", "WRITE", "SAVE"),
        "LoginJournal" to setOf("READ", "EXPORT"),
        "KontrollVerwaltung" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "IMPORT", "EXPORT", "SETTINGS"),
        "Infrastrukturverwaltung" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "SETTINGS"),
        "PalettenTypVerwaltung" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "IMPORT", "EXPORT", "SETTINGS"),
        "WAPlatzTorverwaltung" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "IMPORT", "EXPORT", "SETTINGS"),
        "ParkplatzTorverwaltung" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "IMPORT", "EXPORT", "SETTINGS"),
        "WETorfreigabeScreen" to setOf("READ", "EDIT", "SAVE", "EXPORT", "SETTINGS"),
        "Unternehmenstamm" to setOf("READ", "EDIT", "SAVE", "SETTINGS"),
        "StandortVerwaltung" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "IMPORT", "EXPORT", "SETTINGS", "APPROVE"),
        "NetStandortVerwaltung" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "IMPORT", "EXPORT", "SETTINGS"),
        "SlotView" to setOf("READ", "SETTINGS"),
        "MeineSlotAuftraege" to setOf("READ", "EXPORT", "SETTINGS"),
        "MeineFahrerAuftraege" to setOf("READ", "EXPORT", "SETTINGS"),
        "SlotSetup" to setOf("READ", "WRITE", "SAVE", "SETTINGS", "GENERATE"),
        "LhmTypVerwaltung" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "IMPORT", "EXPORT", "SETTINGS"),
        "MeineZugmaschienen" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "IMPORT", "EXPORT", "SETTINGS"),
        "MeineAuflieger" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "IMPORT", "EXPORT", "SETTINGS"),
        "TorAuskunft" to setOf("READ", "EDIT", "SAVE", "DELETE", "EXPORT", "SETTINGS"),
        "ParkplatzAuskunft" to setOf("READ", "EDIT", "SAVE", "DELETE", "EXPORT", "SETTINGS"),
        "PalettenArtenVerwaltung" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "IMPORT", "EXPORT", "SETTINGS"),
        "PALDashboard" to setOf("READ", "EXPORT", "SETTINGS"),
        "PALVerarbeitung" to setOf("READ", "EDIT", "SAVE", "EXPORT", "SETTINGS"),
        "PALJournal" to setOf("READ", "EDIT", "SAVE", "CREATE", "EXPORT", "SETTINGS"),
        "PALAuskunft" to setOf("READ", "EXPORT", "SETTINGS"),
        "PALDifferenzen" to setOf("READ", "INSTALL", "CANCEL", "EXPORT", "SETTINGS"),
        "StandortLayoutVerwaltung" to setOf("READ", "WRITE", "SAVE"),
        "PlatzAuskunft" to setOf("READ", "EDIT", "SAVE", "DELETE", "EXPORT", "SETTINGS"),
        "WAPlatzAuskunft" to setOf("READ", "EDIT", "SAVE", "DELETE", "EXPORT", "SETTINGS"),
        "Modul Shop" to setOf("READ", "WRITE"),
        "MeineModule" to setOf("READ", "WRITE"),
        "DashboardSmartRing" to setOf("READ", "EDIT", "SAVE"),
        "ScreenAnzeigeModus" to setOf("READ", "EDIT", "SAVE"),
        "ScreenUmgebungen" to setOf("READ", "EDIT", "SAVE"),
        "MobileAnsichten" to setOf("READ", "EDIT", "SAVE"),
        "FeedControlScreen" to setOf("READ", "EDIT", "SAVE"),
 "ZweiFaktorVerwaltung" to setOf("READ", "EDIT", "SAVE", "SETTINGS"),
 "KarteiSeitenVerwaltungScreen" to setOf("READ", "EDIT", "SAVE"),
        "YardSettingsScreen" to setOf("READ", "EDIT", "SAVE", "SETTINGS"),
        "RollenVerwaltung" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE"),
        "BereichsVerwaltung" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE"),
        "CEODashboard" to setOf("READ"),
        "SystemDashboardScreen" to setOf("READ"),
        "SYSSystemDashboard" to setOf("READ", "EXPORT", "SETTINGS"),
        "CUSSupportAuskunft" to setOf("READ", "EXPORT", "SETTINGS"),
        "CUSCRAuskunft" to setOf("READ", "EXPORT", "SETTINGS"),
        "CUSKundenverbrauch" to setOf("READ", "EXPORT", "SETTINGS"),
        "CUSRechnungsuebersicht" to setOf("READ", "EXPORT", "SETTINGS"),
        "CUSTerminauskunft" to setOf("READ", "EXPORT", "SETTINGS"),
        "SYSSupportScreen" to setOf("READ", "WRITE"),
        "SYSCRScreen" to setOf("READ", "WRITE"),
        "SupportAuskunftScreen" to setOf("READ", "EXPORT", "SETTINGS"),
        "CRAuskunft" to setOf("READ", "EXPORT", "SETTINGS"),
        "KunenSetup" to setOf("READ", "EDIT", "SAVE", "CREATE", "IMPORT", "EXPORT", "SETTINGS", "INSTALL", "CANCEL"),
        "KundenDashboard" to setOf("READ"),
        "Vertriebspool" to setOf("READ", "EDIT"),
        "MeineLeads" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "SETTINGS"),
        "LinkedInFlow" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "EXPORT", "SETTINGS"),
        "LinkedInChat" to setOf("READ"),
        "VertriebsDashboard" to setOf("READ"),
        "SYSVertriebsDashboard" to setOf("READ"),
        "Vertriebsindex" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "EXPORT", "SETTINGS"),
        "Konkurrenzindex" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "EXPORT", "SETTINGS"),
        "Leaduebersicht" to setOf("READ", "SETTINGS"),
        "AkquiseEinstellungen" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "IMPORT", "EXPORT"),
        "Kundenabrechnung" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "SETTINGS"),
        "Rechnungsuebersicht" to setOf("READ", "EXPORT", "SETTINGS"),
        "Betriebsausgaben" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "EXPORT", "SETTINGS"),
        "Eingangsrechnungen" to setOf("READ", "EXPORT", "SETTINGS"),
        "FinanzDashboard" to setOf("READ", "EXPORT", "SETTINGS"),
        "FinanzenDashboard" to setOf("READ"),
        "FinanzamtQuartale" to setOf("READ", "EDIT", "SAVE", "SETTINGS"),
        "Abgabeeinstellungen" to setOf("READ", "EDIT", "SAVE", "CREATE", "DELETE", "EXPORT", "SETTINGS"),
        "Modulauskunft" to setOf("READ", "EXPORT", "SETTINGS"),
        "Terminauskunft" to setOf("READ", "EXPORT", "SETTINGS"),
        "SYSDashboardAuskunft" to setOf("READ", "EXPORT", "SETTINGS"),
        "WebseitenUebersicht" to setOf("READ", "EXPORT", "SETTINGS"),
        "WebseitenDashboard" to setOf("READ"),
        "WebseitenWiederkehrer" to setOf("READ", "EXPORT"),
        "Firmenregister" to setOf("READ", "EDIT", "SAVE", "CREATE", "IMPORT", "EXPORT", "SETTINGS", "APPROVE", "CANCEL"),
        "Modul Editor" to setOf("READ", "WRITE"),
        "TabularCreator" to setOf("READ", "WRITE", "SAVE", "CREATE", "DELETE", "IMPORT", "EXPORT"),
        "SysTextToPdfScreen" to setOf("READ", "WRITE", "SAVE", "GENERATE"),
        "ScreenLizenzVerwaltung" to setOf("READ", "EDIT", "SAVE", "INSTALL"),
        "MobileWAAuswahlScreen" to setOf("READ", "WRITE"),
        "MobileWAKontrolleScreen" to setOf("READ", "WRITE", "SAVE"),
        "MobileWEKontrolleScreen" to setOf("READ", "WRITE", "SAVE"),
        "MobileWEAuswahlScreen" to setOf("READ", "WRITE")
    )

    private val licensedExtraCusScreens = emptyList<String>()

    private val refreshDomainsByScreen = mapOf(
        "SnapMeineAuftraegeDashboard" to setOf("slot", "yard", "yard-kontrollen", "snap", "user"),
        "DispoDashboard" to setOf("palettenkonto", "yard"),
        "InfrastrukturDashboard" to setOf("yard", "yard-kontrollen", "company", "mandant"),
        "InfrageneratorDashboard" to setOf("yard", "yard-kontrollen", "infra"),
        "HofDashboard" to setOf("yard", "yard-kontrollen"),
        "ZeitfensterDashboard" to setOf("slot", "yard", "meinefahrzeuge", "company"),
        "SystemBuild" to setOf("system", "build"),
        "BuildDashboard" to setOf("system", "build", "node", "worker"),
        "SystemBuildUebersicht" to setOf("system", "build"),
        "SystemBuildJournal" to setOf("system", "build"),
        "SystemNodeAuskunft" to setOf("system", "node", "worker"),
        "NotepadSystem" to setOf("notepad", "notizen"),
        "MobileNotepadSystem" to setOf("notepad", "notizen"),
        "NodeUebersicht" to setOf("node"),
        "Kalender" to setOf("kalender"),
        "AufgabenKalender" to setOf("aufgaben"),
        "KontaktKalender" to setOf("kalender"),
        "ChatModuleScreen" to setOf("chat"),
        "CRErstellung" to setOf("cr"),
        "SupportFlowScreen" to setOf("support"),
        "SchulungsFlowScreen" to setOf("schulung", "kalender"),
        "SchulungsAuskunft" to setOf("schulung", "user"),
        "Schulungsverwaltung" to setOf("schulung", "kalender", "user"),
        "MitarbeiterKalender" to setOf("kalender", "schulung", "urlaub", "zeit"),
        "AufgabenViewer" to setOf("aufgaben"),
        "MitarbeiterMeinUrlaub" to setOf("urlaub", "kalender", "zeit", "user"),
        "MitarbeiterZeitkonto" to setOf("zeit", "urlaub", "user"),
        "Zeiterfassung" to setOf("zeit", "personal", "user"),
        "Arbeitszeitverwaltung" to setOf("personal", "urlaub", "kalender", "user", "zeit"),
        "Buchungsjournal" to setOf("zeit", "personal", "user", "urlaub"),
        "Personalverwaltung" to setOf("personal", "user", "urlaub", "zeit", "standort"),
        "Urlaubsuebersicht" to setOf("urlaub", "kalender", "user", "personal", "zeit"),
        "Zeitverwaltung" to setOf("zeit", "urlaub", "kalender", "user", "personal"),
        "Stempeluhr" to setOf("zeit", "user", "personal"),
        "StempeluhrGenerator" to setOf("zeit", "personal", "standort"),
        "Stempelkarte" to setOf("user", "personal"),
        "TorUebersicht" to setOf("yard", "yard-kontrollen"),
        "RegalUebersicht" to setOf("yard", "yard-kontrollen"),
        "WAPlatzUebersicht" to setOf("yard", "yard-kontrollen"),
        "WarenausgangVorbereitungScreen" to setOf("yard", "yard-kontrollen"),
        "LeitstandHofScreen" to setOf("yard", "yard-kontrollen"),
        "SnapHofuebersicht" to setOf("yard", "yard-kontrollen", "snap"),
        "AuftraegeDashboardScreen" to setOf("yard", "yard-kontrollen"),
        "SnapAuftragsDashboard" to setOf("yard", "yard-kontrollen", "snap"),
        "EndToEndFlowScreen" to setOf("yard", "slot", "snap"),
        "WEAuskunftScreen" to setOf("yard", "yard-kontrollen"),
        "WEWebKontrolleAuskunftScreen" to setOf("yard", "yard-kontrollen"),
        "WAAuskunftScreen" to setOf("yard", "yard-kontrollen"),
        "Snapverwaltung" to setOf("snap", "company", "mandant", "firmenstamm"),
        "UserVerwaltung" to setOf("user"),
        "UserVerwaltungTabelle" to setOf("user"),
        "MeinProfilScreen" to setOf("profil", "user", "kontakte"),
        "ServiceBuchen" to setOf("kalender", "user"),
        "LoginJournal" to setOf("loginjournal", "user"),
        "KontrollVerwaltung" to setOf("yard-kontrollen"),
        "Infrastrukturverwaltung" to setOf("yard", "infra"),
        "PalettenTypVerwaltung" to setOf("yard"),
        "WAPlatzTorverwaltung" to setOf("yard", "yard-kontrollen"),
        "ParkplatzTorverwaltung" to setOf("yard", "yard-kontrollen"),
        "WETorfreigabeScreen" to setOf("yard", "company", "mandant"),
        "Unternehmenstamm" to setOf("unternehmen", "company"),
        "StandortVerwaltung" to setOf("yard"),
        "NetStandortVerwaltung" to setOf("yard"),
        "MeineSlotAuftraege" to setOf("slot", "yard", "user"),
        "MeineFahrerAuftraege" to setOf("slot", "yard", "user"),
        "SlotSetup" to setOf("slot", "yard"),
        "LhmTypVerwaltung" to setOf("yard"),
        "MeineZugmaschienen" to setOf("meinefahrzeuge", "company"),
        "MeineAuflieger" to setOf("meinefahrzeuge", "company"),
        "TorAuskunft" to setOf("yard", "yard-kontrollen"),
        "ParkplatzAuskunft" to setOf("yard"),
        "PalettenArtenVerwaltung" to setOf("yard"),
        "PALDashboard" to setOf("palettenkonto", "yard"),
        "PALVerarbeitung" to setOf("palettenkonto", "yard"),
        "PALJournal" to setOf("palettenkonto"),
        "PALAuskunft" to setOf("palettenkonto"),
        "PALDifferenzen" to setOf("palettenkonto"),
        "StandortLayoutVerwaltung" to setOf("yard"),
        "PlatzAuskunft" to setOf("yard"),
        "WAPlatzAuskunft" to setOf("yard"),
        "Modul Shop" to setOf("module", "lizenz"),
        "MeineModule" to setOf("module", "lizenz"),
        "DashboardSmartRing" to setOf("user", "yard", "module"),
        "ScreenAnzeigeModus" to setOf("screenanzeigemodus"),
        "ScreenUmgebungen" to setOf("screenumgebung"),
        "MobileAnsichten" to setOf("mobileansichten"),
        "FeedControlScreen" to setOf("feedcontrol"),
        "KarteiSeitenVerwaltungScreen" to setOf("kartei"),
        "YardSettingsScreen" to setOf("yard", "settings"),
        "RollenVerwaltung" to setOf("rolle"),
        "BereichsVerwaltung" to setOf("bereich"),
        "CUSSupportAuskunft" to setOf("support"),
        "CUSCRAuskunft" to setOf("cr"),
        "SupportAuskunftScreen" to setOf("support"),
        "SYSSupportScreen" to setOf("support"),
        "SYSCRScreen" to setOf("cr"),
        "CRAuskunft" to setOf("cr"),
        "KunenSetup" to setOf("module", "user", "company"),
        "KundenDashboard" to setOf("module", "user", "company", "kalender", "Kundenabrechnung"),
        "Vertriebspool" to setOf("vertriebsindex", "company"),
        "MeineLeads" to setOf("vertriebsindex", "company", "linkedinvertriebsindex", "linkedinflow"),
        "LinkedInFlow" to setOf("vertriebsindex", "linkedinflow", "linkedinvertriebsindex", "company"),
        "LinkedInChat" to setOf("linkedinflow", "linkedinvertriebsindex"),
        "VertriebsDashboard" to setOf("vertriebsindex", "company"),
        "SYSVertriebsDashboard" to setOf("vertriebsindex", "company"),
        "Vertriebsindex" to setOf("vertriebsindex", "company"),
        "Konkurrenzindex" to setOf("vertriebsindex", "company"),
        "Leaduebersicht" to setOf("vertriebsindex", "company", "linkedinflow"),
        "AkquiseEinstellungen" to setOf("vertriebsindex", "settings", "linkedinflow"),
        "Kundenabrechnung" to setOf("module", "Kundenabrechnung"),
        "Rechnungsuebersicht" to setOf("module", "Kundenabrechnung"),
        "Betriebsausgaben" to setOf("finanzen", "betriebsausgaben", "eingangsbelege"),
        "Eingangsrechnungen" to setOf("finanzen", "eingangsrechnungen", "monate", "ausgaben"),
        "FinanzDashboard" to setOf("finanzen", "dashboard", "umsatz", "steuer", "ergebnis"),
        "FinanzenDashboard" to setOf("finanzen", "dashboard", "umsatz", "steuer", "ergebnis", "eingangsrechnungen", "ausgaben", "abgaben"),
        "FinanzamtQuartale" to setOf("finanzen", "eingangsrechnungen", "steuer"),
        "Abgabeeinstellungen" to setOf("finanzen", "abgaben", "steuer", "versicherung"),
        "Modulauskunft" to setOf("module", "company"),
        "Terminauskunft" to setOf("kalender", "company"),
        "CUSKundenverbrauch" to setOf("module", "kundenverbrauch"),
        "CUSRechnungsuebersicht" to setOf("module", "kundenverbrauch"),
        "CUSTerminauskunft" to setOf("kalender", "company"),
        "SystemDashboardScreen" to setOf("yard", "yard-infra", "yard-tor", "yard-parkplatz", "palettenkonto", "snap", "slot", "support", "cr"),
        "SYSSystemDashboard" to setOf("module", "Kundenabrechnung", "company", "kalender", "support", "cr"),
        "SYSDashboardAuskunft" to setOf("screenanzeigemodus", "rolle", "lizenz", "user"),
        "Modul Editor" to setOf("module", "lizenz"),
        "TabularCreator" to setOf("tabular"),
        "SysTextToPdfScreen" to setOf("service"),
        "ScreenLizenzVerwaltung" to setOf("lizenz", "screenlizenzverwaltung", "module"),
        "Firmenregister" to setOf("company"),
        "MobileWEAuswahlScreen" to setOf("yard", "yard-kontrollen"),
        "MobileWEKontrolleScreen" to setOf("yard", "yard-kontrollen"),
        "MobileWAAuswahlScreen" to setOf("yard", "yard-kontrollen"),
        "MobileWAKontrolleScreen" to setOf("yard", "yard-kontrollen"),
        "DriverMeineAuftraege" to setOf("yard"),
        "DriverYardLobbyScreen" to setOf("yard")
    )

    private val statefulLiveScreens = setOf(
        "TorUebersicht",
        "RegalUebersicht",
        "WAPlatzUebersicht",
        "WarenausgangVorbereitungScreen",
        "LeitstandHofScreen",
        "SnapHofuebersicht",
        "AuftraegeDashboardScreen",
        "SnapAuftragsDashboard",
        "EndToEndFlowScreen",
        "WEAuskunftScreen",
        "WEWebKontrolleAuskunftScreen",
        "WAAuskunftScreen",
        "Snapverwaltung",
        "WETorfreigabeScreen",
        "MeineSlotAuftraege",
        "MeineFahrerAuftraege",
        "TorAuskunft",
        "ParkplatzAuskunft",
        "PlatzAuskunft",
        "WAPlatzAuskunft",
        "SlotView",
        "SlotSetup",
        "MobileWEAuswahlScreen",
        "MobileWEKontrolleScreen",
        "MobileWAAuswahlScreen",
        "MobileWAKontrolleScreen",
        "DriverMeineAuftraege",
        "DriverYardLobbyScreen"
    )

    private var screenConfig: Map<String, Map<String, String>> = emptyMap()
    private var screenEnvironments: Map<String, All> = emptyMap()
    private var runtimeEnvironment: String = ""
    private var runtimeNodeId: String = ""

    fun applyNodeIdentity(nodeId: String) { runtimeNodeId = nodeId }
    fun isLinkedInNode(): Boolean = runtimeNodeId.isNotBlank()

    private fun isScreenAllowed(key: String, node: String): Boolean =
        (key !in setOf("LinkedInChat", "SYSVertriebsDashboard") || node == DashboardNode.SYS && isLinkedInNode()) &&
        (key != "LinkedInFlow" || node in setOf(DashboardNode.SYS, DashboardNode.CUS)) &&
        !(key == "VertriebsDashboard" && node == DashboardNode.SYS && isLinkedInNode()) &&
        (node != DashboardNode.SYS || when (runtimeEnvironment) {
            "dev" -> screenEnvironments[key]?.dev != false
            "live" -> screenEnvironments[key]?.live != false
            else -> true
        })

    private fun screenMetaByKey(key: String): All =
        screenKeyIndex[key] ?: All(key = key, label = key)

    private fun configuredModeForKey(key: String): String =
        screenConfig[key]?.get("mode")?.takeIf { it.isNotBlank() } ?: ScreenMode.CONTENT

    private fun resolvedArt(node: String): String =
        when (node) {
            DashboardNode.CUS, DashboardNode.CUS_MOBILE -> NodeScope.CUS
            DashboardNode.NET -> NodeScope.NET
            else -> NodeScope.SYS
        }

    private fun categoryEntries(category: All, node: String): List<All> =
        category.columns
            .filter { key -> isScreenAllowed(key, node) }
            .map { key ->
                val meta = screenMetaByKey(key)
                meta.copy(
                    art = resolvedArt(node),
                    bereich = node,
                    screenMode = configuredModeForKey(key),
                    screenCategory = category.bezeichnung
                )
            }

    private fun resolvedEntries(node: String): List<All> =
        dashboardBlocks[node]
            ?.module
            ?.flatMap { category -> categoryEntries(category, node) }
            .orEmpty()

    fun labelForKey(key: String): String = screenMetaByKey(key).label

    fun administrativeLabelForKey(key: String): String =
        screenMetaByKey(key).verwaltungsLabel

    fun iconForKey(key: String): String = screenMetaByKey(key).icon

    fun karteiPagesForKey(key: String): List<All> = screenMetaByKey(key).module

    fun supportedActionsForKey(key: String): Set<String> =
        supportedActionsByScreen[key].orEmpty()

    fun allIndexKeys(): List<String> = screenKeyIndex.keys.toList()

    fun defaultScreenModeForKey(): String = ScreenMode.CONTENT

    fun applyScreenConfig(config: Map<String, Map<String, String>>) {
        screenConfig = config
    }

    fun currentScreenConfig(): Map<String, Map<String, String>> = screenConfig

    fun applyScreenEnvironments(config: List<All>, environment: String) {
        screenEnvironments = config.associateBy { it.screenKey }
        runtimeEnvironment = environment.trim().lowercase()
    }

    fun personalProfileScreen(node: String): All =
        screenMetaByKey("MeinProfilScreen").copy(
            art = resolvedArt(node),
            bereich = node,
            screenMode = ScreenMode.CONTENT
        )

    fun companyIdentityScreen(node: String): All {
        val key = when (node) {
            DashboardNode.SYS -> "Unternehmenstamm"
            DashboardNode.NET -> "NetStandortVerwaltung"
            else -> "StandortVerwaltung"
        }
        return screenMetaByKey(key).copy(
            art = resolvedArt(node),
            bereich = node,
            screenMode = ScreenMode.CONTENT
        )
    }

    fun standortLayoutScreen(node: String): All =
        screenMetaByKey("StandortLayoutVerwaltung").copy(
            art = resolvedArt(node),
            bereich = node,
            screenMode = ScreenMode.CONTENT
        )

    fun kontaktKalenderScreen(node: String): All =
        screenMetaByKey("KontaktKalender").copy(
            art = resolvedArt(node),
            bereich = node,
            screenMode = ScreenMode.CONTENT
        )

    fun schulungFlowScreen(node: String): All =
        screenMetaByKey("SchulungsFlowScreen").copy(
            art = resolvedArt(node),
            bereich = node,
            screenMode = ScreenMode.CONTENT
        )

    fun licensedExtraCusScreenKeys(): List<String> =
        licensedExtraCusScreens.filter { it in screenKeyIndex }

    fun licensableCusScreenKeys(): List<String> =
        (
            allScreenKeys(DashboardNode.CUS) +
                allScreenKeys(DashboardNode.CUS_MOBILE) +
                licensedExtraCusScreenKeys()
            )
            .distinct()
            .filter { it in screenKeyIndex && it !in dashboardChildren["VertriebsDashboard"].orEmpty() }

    fun rawDashboardIndex(node: String): All {
        val block = dashboardBlocks[node] ?: return All()
        val modules = block.module.mapNotNull { category ->
            val entries = categoryEntries(category, node)
            category.takeIf { entries.isNotEmpty() }?.copy(columnSettings = entries)
        }
        val flatEntries = modules.flatMap { it.columnSettings }
        return All(
            typ = block.typ,
            module = modules,
            categoryIcons = block.categoryIcons,
            preise = flatEntries
        )
    }

    fun mobileDashboardScreens(node: String): List<All> {
        val mobileArt = if (node == DashboardNode.SYS_MOBILE) NodeScope.SYS else NodeScope.CUS
        return rawDashboardIndex(node).preise.map { screen ->
            if (screen.key == "ChatModuleScreen") {
                screen.copy(content = { MobileChatLayout(art = mobileArt) })
            } else {
                screen
            }
        }
    }

    private fun descendantScreenKeys(key: String, visited: Set<String> = emptySet()): List<String> {
        if (key in visited) return emptyList()
        val nextVisited = visited + key
        return dashboardChildren[key].orEmpty().flatMap { child ->
            listOf(child) + descendantScreenKeys(child, nextVisited)
        }.distinct()
    }

    fun codeNodesForKey(key: String): List<String> =
        dashboardBlocks
            .filterValues { block -> block.module.any { category -> category.columns.any { it == key || key in descendantScreenKeys(it) } } }
            .keys
            .toList()

    fun allScreenKeys(node: String): List<String> =
        resolvedEntries(node)
            .flatMap { listOf(it.key) + descendantScreenKeys(it.key).filter { child -> isScreenAllowed(child, node) } }
            .distinct()

    fun roleScreenKeys(node: String): List<String> =
        when (node) {
            DashboardNode.CUS -> (allScreenKeys(DashboardNode.CUS) + allScreenKeys(DashboardNode.CUS_MOBILE)).distinct()
            DashboardNode.SYS -> (allScreenKeys(DashboardNode.SYS) + allScreenKeys(DashboardNode.SYS_MOBILE)).distinct()
            else -> allScreenKeys(node)
        }

    fun mobileScreenKeys(node: String): List<String> = allScreenKeys(node)

    fun matchesResource(screenKey: String, resource: String): Boolean {
        val normalizedResource = resource.trim().lowercase()
        if (normalizedResource.isBlank()) return false
        return refreshDomainsByScreen[screenKey]
            .orEmpty()
            .map { it.trim().lowercase() }
            .any { domain ->
                if (domain == "yard") {
                    normalizedResource == domain ||
                        (screenKey in statefulLiveScreens && normalizedResource.startsWith("yard-"))
                } else {
                    normalizedResource == domain ||
                        normalizedResource.startsWith("$domain.") ||
                        normalizedResource.startsWith("$domain-")
                }
            }
    }

    fun remountsOnResourceRefresh(screenKey: String): Boolean {
        val domains = refreshDomainsByScreen[screenKey].orEmpty().map { it.trim().lowercase() }
        return domains.none { it == "yard" || it.startsWith("yard-") } && screenKey !in statefulLiveScreens
    }

    fun allowedMobileCusScreens(
        effectiveScreens: List<String>,
        canRead: (String) -> Boolean
    ): List<String> =
        mobileScreenKeys(DashboardNode.CUS_MOBILE).filter { it in effectiveScreens && canRead(it) }

    fun resolveDashboard(node: String): All {
        val block = dashboardBlocks[node] ?: return All()
        val modules = block.module.mapNotNull { category ->
            val entries = categoryEntries(category, node)
            val top = entries.filter { it.screenMode == ScreenMode.POPUP }
            val sidebar = entries.filter { it.screenMode == ScreenMode.CONTENT }
            category.takeIf { top.isNotEmpty() || sidebar.isNotEmpty() }?.copy(columnSettings = sidebar, lizenzen = top)
        }
        val top = modules.flatMap { it.lizenzen }
        val sidebarEntries = modules.flatMap { it.columnSettings }
        return All(
            typ = block.typ,
            lizenzen = top,
            preise = sidebarEntries,
            module = modules.map { it.copy(lizenzen = emptyList()) },
            categoryIcons = block.categoryIcons
        )
    }
}
